import { MouseEvent } from "react";

export const openPopupWithParams = (event: MouseEvent, SchemeIdBindObject: number) => {
  const popupWidth = Math.round(window.screen.width / 2.6);
  const popupHeight = Math.round(window.screen.height / 2.6);

  const x = event.screenX;
  const y = event.screenY;

  const currentUrl = window.location.href;
  const newUrl = new URL(currentUrl);
  newUrl.searchParams.delete("stationId");
  newUrl.searchParams.set("trainId", String(SchemeIdBindObject));
  newUrl.searchParams.set("onlyPage", "true");
  newUrl.searchParams.set("component", "train");

  window.open(newUrl.toString(), "_blank", `width=${popupWidth},height=${popupHeight},left=${x},top=${y}`);
};
